import { mkNotifications, mkTrackPending } from "../redux";

export const pending = mkTrackPending("pending");
export const notifications = mkNotifications("notifications");
